module.exports = __webpack_public_path__ + "static/media/AlaskaAirlinesHeroBanner.c6ff12ab.png";